import { AxiosResponse } from "axios";
import axiosInstance from "../../api";
import suggestiveInputHelpers from "../helpers/suggestiveInputHelpers";

function NeuroIDgenetixMedicartionsSideEffect(
  token: string,
  testType: string,
  setSuggestions: (response: AxiosResponse) => any
) {
  axiosInstance
    .get(`v1/medications`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      if (response.data.data) {
        setSuggestions(
          response.data.data
            .sort(suggestiveInputHelpers.sortByAlphabeticalOrder)
            .filter((obj: any, index: number, self: any) => {
              return index === self.findIndex((o: any) => obj.name === o.name);
            })
            .map((item: any) => ({
              label: item.label,
              value: item.name,
            }))
        );
      }
    });
}

export default NeuroIDgenetixMedicartionsSideEffect;
